<mat-form-field class="chip-form-field" [class.isError]="isError()" appearance="outline">
  <mat-chip-grid #chipList>
    @for (chip of selectedChips; track chip.id) {
      <mat-chip-row (removed)="remove(chip.id)">
        {{ chip.short_name }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }

    <input
      #chipInput
      placeholder="Select"
      (click)="onClick()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      [formControl]="inputCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event, chipInput)">
  </mat-chip-grid>

  <mat-autocomplete
    #auto="matAutocomplete"
    class="mc-mat-autocomplete"
    (optionSelected)="selected($event)">
    @for (chip of allChips(); track chip.id) {
      <mat-option
        [value]="chip.id"
        [disabled]="isDisabled(chip.id)">
        {{ chip.short_name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
